import React from 'react';
import {
  Box, Grid, Tab, ThemeProvider, Typography,
} from '@mui/material';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import { useLocation, useNavigate, Outlet } from 'react-router-dom';
import { nextTheme } from '../../theme';
import { useAwoContext } from '../AwoContextProvider';

function SettingsContainer() {
  const { awo } = useAwoContext();
  const location = useLocation();
  const navigate = useNavigate();

  const getActiveTab = () => {
    if (location.pathname === '/settings/members') return '2';
    if (location.pathname === '/settings/reports') return '3';
    return '1';
  };

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    if (newValue === '1') navigate('/settings');
    if (newValue === '2') navigate('/settings/members');
    if (newValue === '3') navigate('/settings/reports');
  };

  return (
    <ThemeProvider theme={nextTheme}>
      <Box sx={{
        pt: 3,
        pb: {
          xs: 2,
          lg: 3,
        },
        minHeight: '100vh',
      }}
      >
        <Grid sx={{ px: { xs: 3.5 } }} spacing={2} container direction="row" alignItems="center" justifyContent="space-between">
          <Grid item xs={12}>
            <Typography variant="h5">{awo?.name}</Typography>
          </Grid>
        </Grid>
        <Grid container sx={{ pt: { xs: 2, md: 3 } }}>
          <Grid item xs={12}>
            <TabContext value={getActiveTab()}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider', px: 2 }}>
                <TabList onChange={handleChange} aria-label="shelter settings">
                  <Tab label="Settings" value="1" />
                  <Tab label="Members" value="2" />
                  {!awo?.preSurrenderDashboard ? (
                    <Tab label="Reports" value="3" />
                  ) : null}
                </TabList>
              </Box>
              <Box sx={{ p: { xs: 2 } }}>
                <Outlet />
              </Box>
            </TabContext>
          </Grid>
        </Grid>
      </Box>
    </ThemeProvider>
  );
}

export default SettingsContainer;
